module.exports = __webpack_public_path__ + "static/media/cnbc.e187a614.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/media/images/cnbc.png
// module id = 1797
// module chunks = 146